"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var slots_slider_1 = __importDefault(require("@l2p/slots-slider"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_2 = require("@l2p/ui-components");
var ui_components_3 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var BlockWithGames = function (_a) {
    var _b;
    var provider = _a.provider, gameCardPlaceholder = _a.gameCardPlaceholder, _c = _a.columnsCount, columnsCount = _c === void 0 ? 5 : _c, correctionCoefficient = _a.correctionCoefficient;
    var _d = (0, swr_hooks_1.useCurrentProviderGames)({
        id: provider === null || provider === void 0 ? void 0 : provider.id,
    }), games = _d.data, gamesLoading = _d.isLoading, mutate = _d.mutate, isValidating = _d.isValidating;
    var prevProviderId = (0, react_1.useRef)(provider === null || provider === void 0 ? void 0 : provider.id);
    var _e = (0, react_1.useState)(), utils = _e[0], setUtils = _e[1];
    var gamesBlocks = (0, apps_shared_1.useGenerateSlideBlocks)({
        cards: games || [],
        cardsInSlide: 6,
    });
    (0, react_1.useEffect)(function () {
        if (prevProviderId.current && prevProviderId.current !== (provider === null || provider === void 0 ? void 0 : provider.id)) {
            mutate === null || mutate === void 0 ? void 0 : mutate();
        }
        prevProviderId.current = provider === null || provider === void 0 ? void 0 : provider.id;
    }, [mutate, provider === null || provider === void 0 ? void 0 : provider.id]);
    if (gamesLoading || isValidating)
        return react_1.default.createElement(ui_components_3.LoadingWithContainer, null);
    if (!gamesBlocks || (gamesBlocks === null || gamesBlocks === void 0 ? void 0 : gamesBlocks.length) === 0)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.blockWrapper },
        react_1.default.createElement(ui_components_1.TopBar, { setPrevSlide: utils === null || utils === void 0 ? void 0 : utils.setPrevSlide, setNextSlide: utils === null || utils === void 0 ? void 0 : utils.setNextSlide, title: (provider === null || provider === void 0 ? void 0 : provider.title) || '', showNavigationButtons: gamesBlocks && gamesBlocks.length > 1, linkAddress: "/providers/".concat((_b = provider === null || provider === void 0 ? void 0 : provider.slug) === null || _b === void 0 ? void 0 : _b.toLowerCase()) }),
        react_1.default.createElement(slots_slider_1.default, { duration: 1, getSliderMethods: function (utils) { return setUtils(utils); }, columnsCount: columnsCount, gapBetweenCards: 15, rowsCount: 1, correctionCoefficient: correctionCoefficient }, gamesBlocks === null || gamesBlocks === void 0 ? void 0 : gamesBlocks.map(function (slideGames, slideIdx) {
            var _a;
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.slide, key: "gamesSlider".concat(provider === null || provider === void 0 ? void 0 : provider.id).concat(slideIdx).concat((_a = slideGames === null || slideGames === void 0 ? void 0 : slideGames[0]) === null || _a === void 0 ? void 0 : _a.id) }, slideGames === null || slideGames === void 0 ? void 0 : slideGames.map(function (game, idx) {
                var _a;
                return (react_1.default.createElement(ui_components_2.DesktopGameCard, { withDemo: (_a = game === null || game === void 0 ? void 0 : game.settings) === null || _a === void 0 ? void 0 : _a['demo'], key: "".concat(provider === null || provider === void 0 ? void 0 : provider.slug).concat(game.id).concat(idx), gameId: game.id, slug: game.slug, title: game.title, gameCardPlaceholder: gameCardPlaceholder, signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL }));
            })));
        }))));
};
exports.default = react_1.default.memo(BlockWithGames);
